
<div class="row">
  <div class="col-12">
    <div class="row mb-3">
      <div class="col-12">
        <select id="sel_timeweek" class="form-select form-select-sm" [(ngModel)]="gridFilters.timeWeekKey"
                (change)="loadWeekData($event)">
          <option value="">-- Choose Week --</option>
          <option *ngFor="let week of listTimeWeeks; trackBy: trackByFn" [value]="week.id">Week {{ week.wk }}: {{ week.wkstart }} - {{week.wkend}}</option>
        </select>
      </div>
    </div>
    <div class="row" *ngIf="(errorMessage != '')">
      <div class="col-12 text-center">
        <div [className]="errorClass" id="weeklyError">
          <span [className]="errorText">{{errorMessage}}</span>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-md-4">
        <div class="weekly-update-container">
          <div class="card mb-2">
            <div class="card-body p-2">
              List any roadblocks you experienced or overcame this week and briefly describe any that are ongoing.<br /><b>Put each item on a new line.</b>
            </div>
          </div>
          <textarea id="ta_roadblocks" class="form-control form-control-sm mb-4"
                    [(ngModel)]="weeklyUpdate.roadblocks"
                    rows="4"
                    placeholder="Put each item on a new line">
          </textarea>

          <div class="card my-2">
            <div class="card-body p-2">
              In preparation for next Monday's Vespers, list 3-5 Priorities for the upcoming week. You can simply look at your calendar for next week and organize your 3-5 areas of focus based on the events there.<br />
              <b>Put each item on a new line.</b>
            </div>
          </div>
          <textarea id="ta_nextweek" class="form-control form-control-sm mb-4"
                    [(ngModel)]="weeklyUpdate.nextWeek"
                    rows="4"
                    placeholder="Put each item on a new line"></textarea>

          <div class="row mb-2">
            <div class="col-12 col-md-9">
              Save to preview or submit your report
            </div>
            <div class="col-12 col-md-3 text-end">
              <button class="btn btn-sm btn-primary" (click)="saveComments()" style="width:100%">
                <i class="fas fa-fw fa-save me-1"></i>Save
              </button>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-md-9">
              Generate Preview
            </div>
            <div class="col-12 col-md-3 text-end">
              <button [disabled]="!previewEnabled" class="btn btn-sm btn-primary" (click)="downloadPreview()" style="width:100%">
                <i class="fas fa-fw fa-eye me-1"></i>Preview
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-9">
              <select class="form-select form-select-sm" [(ngModel)]="toAddress" id="to_address" [disabled]="!sendEnabled">
                <option *ngFor="let recip of listAddresses; trackBy: trackByFn" [value]="recip.key">Submit to: {{ recip.value }}</option>
              </select>
            </div>
            <div class="col-12 col-md-3 text-end">
              <button class="btn btn-sm btn-success" (click)="sendUpdate()" [disabled]="!sendEnabled" style="width:100%">
                <i class="fas fa-fw fa-paper-plane me-2"></i>Send
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="row" *ngIf="reportTarget == 'iframe'">
          <div class="col-12">
            <iframe id="weeklyFrame" src="https://os.welara.com/rpt.html" style="width:100%;height:70vh;border:solid 1px #ccc;padding:8px"></iframe>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<!--<div class="row">
  <div class="col-12">
    <iframe src="https://uat-reporting.welara.com/index.aspx?uid=18&wk=12&yr=2025" style="width:100%;height:40vh"></iframe>
  </div>
</div>-->
